import {useTranslation} from 'react-i18next';

import {getAssetFeedSubtitle} from '@/features/buyers/utils';
import {useTrustTypeStrategy} from '@/features/trust-accounts/providers';

import {ACTIVITY_ICONS, REQUEST_ACTIVITY_TYPES} from '../activity-presentation';
import {ActivityFeedRowLayout} from '../ActivityFeedRowLayout';
import {ActivityAmountBadge} from './ActivityAmountBadge';
import {BuyerNamesSummary} from './BuyerNamesSummary';
import {castMetadata, readAssetSummary, readBuyerNames} from './metadata.utils';

import type {BuyerDepositMetadata, TrustAccountActivityDTO} from '@sollapay/types';

interface BuyerDepositRowProps {
  activity: TrustAccountActivityDTO;
}

export function BuyerDepositRow({activity}: BuyerDepositRowProps) {
  const {t} = useTranslation('trustAccounts');
  const {allowsMultipleAssets} = useTrustTypeStrategy();
  const meta = castMetadata<BuyerDepositMetadata>(activity);
  const asset = readAssetSummary(activity);
  const buyerNames = readBuyerNames(meta);

  return (
    <ActivityFeedRowLayout
      icon={ACTIVITY_ICONS[activity.activityType]!}
      title={t(`view.activity.activityType.${activity.activityType}`)}
      actorName={buyerNames.length > 0 ? <BuyerNamesSummary buyerNames={buyerNames} /> : null}
      subtitle={getAssetFeedSubtitle(asset, t, allowsMultipleAssets)}
      createdAt={activity.createdAt}
      action={
        meta?.amount ? (
          <ActivityAmountBadge
            amount={meta.amount}
            variant="credit"
            pending={REQUEST_ACTIVITY_TYPES.has(activity.activityType)}
          />
        ) : undefined
      }
    />
  );
}
